import * as React from 'react';

const SvgCurrencyNotFill = (props) => (
  <svg
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M18 16c0-5.485-3.582-9.931-8-9.931M2 16c0-5.485 3.582-9.931 8-9.931m0 0v8.276m0-8.276V4' />
  </svg>
);

export default SvgCurrencyNotFill;
